var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErroricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11282",
    "data-name": "Path 11282",
    d: "M390.5,385.5a8,8,0,1,1-7.994-8A8.006,8.006,0,0,1,390.5,385.5Zm-6.712-3.456a2.045,2.045,0,0,0-.2-1.181,1.224,1.224,0,0,0-1.213-.65,1.272,1.272,0,0,0-1.069.919,3.2,3.2,0,0,0-.069,1.194,21.2,21.2,0,0,0,.844,4.037.845.845,0,0,0,.15.287.321.321,0,0,0,.531,0,1.135,1.135,0,0,0,.169-.35c.119-.406.225-.819.331-1.238A15.5,15.5,0,0,0,383.787,382.044Zm-1.275,6.356a1.1,1.1,0,0,0-.019,2.206,1.1,1.1,0,0,0,.019-2.206Z",
    transform: "translate(-374.5 -377.5)",
    fill: "#fbb516"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErroricon);
export default __webpack_public_path__ + "static/media/error icon.56731cd19c11d388ec3fe4aea2ba8e5d.svg";
export { ForwardRef as ReactComponent };